/**
*
*   Next Intl: Navigation
*       - Moved to: /i18n/routing
* 		- Relinks code
*
**/
import Config from '@/config';
import { routing } from '@/i18n/routing';
import { createNavigation } from 'next-intl/navigation';

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);